import { Dictionary } from "./dictionary";
import { FormControlTypes, FormPosition } from "./form-base-control.model";

export class form_control {
  name?: string;
  label?: string;
  required?: boolean;
  order?: number;
  tabOrder?: number;
  controlType?: FormControlTypes;
  modelName?: string;
  textType?: string;
  minLength?: number;
  maxLength?: number;
  min?: number;
  max?: number;
  hidden?: boolean;
  placeholder?: string;
  isDecimal?: boolean;
  isNumberOnly?: boolean;
  isFloat?: number;
  columnNumber?: number;
  columnWidth?: number;
  decimalsLength?: number;
  apiName?: string;
  valueMember?: string;
  displayMember?: string;
  columnsName?: string;
  formVisible: boolean;
  listVisible: boolean;
  disabled: boolean = false;
  dataList?: any[];
  parentIdName?: String;
  withComma?: boolean = true;
  IsMultiSelect?: boolean = false;
  patternKey?: string;
  filterKey?: string;
  format?: string;
  inputMask?: string;
  DetailControlModels: Dictionary;
  areaName: string;
  systemName: string;
  category: string;
  userClass?: string;
  formPosition?: FormPosition;
  isMulti?: boolean = false;
  isNullable?: boolean = false;
  hideTheme?: boolean = false;
  inputMode?: string;
  SortColumn?: string;
  accept?: string;
  isGetPath?: boolean;
  IsEqual?: boolean;
  buttonIcon?: string;
  getBgColor?: (data: any) => string;
  isSelector?: boolean;
}

export class actionInfo {
  apiName: string;
  actionName: string;
  active: boolean;
}
